// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2TLNH","name":"ConsentHeader_name__2_9iY","birthday":"ConsentHeader_birthday__3-XSe","skeleton":"ConsentHeader_skeleton__OPwjV"};